import { render, staticRenderFns } from "./VisualMenuButton.vue?vue&type=template&id=1ed0141a&scoped=true&"
import script from "./VisualMenuButton.vue?vue&type=script&lang=js&"
export * from "./VisualMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./VisualMenuButton.vue?vue&type=style&index=0&id=1ed0141a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed0141a",
  null
  
)

export default component.exports